export class SetTrackerParameterDto
{
    wifiEnabled?: boolean;
    operatorId?: string;
    updatePeriodS?: number;
}